var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 120,
    viewBox: "0 0 109 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 120,
    rx: 20,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2 70.0005C30.316 70.0005 25.597 68.1672 22 64.8672V80.0005C22 85.5005 26.455 90.0005 31.9 90.0005H78.1C83.545 90.0005 88 85.5005 88 80.0005V64.8672C84.403 68.1672 79.684 70.0005 74.8 70.0005H35.2Z",
    fill: "#00A90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1 40H68.2C68.2 34.4667 63.778 30 58.3 30H51.7C46.222 30 41.8 34.4667 41.8 40H31.9C26.455 40 22 44.5 22 50C22 57.3667 27.907 63.3333 35.2 63.3333H74.8C82.093 63.3333 88 57.3667 88 50C88 44.5 83.545 40 78.1 40ZM51.7 36.6667H58.3C60.115 36.6667 61.6 38.1667 61.6 40H48.4C48.4 38.1667 49.885 36.6667 51.7 36.6667Z",
    fill: "#00A90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv2);
export default __webpack_public_path__ + "static/media/div2.1c4abc325b15366a4860be31706cac31.svg";
export { ForwardRef as ReactComponent };